<div class="chat-container">
  <div class="chatbot-header">
    <label>MS Bot</label>
    <button (click)="closeChatbot()" id="closeChatbot">X</button>
  </div>
  <div class="chat-box" #scrollContainer>
    <ng-container *ngIf="!error; else errorBlock" >
    <div class="chat-message-container" *ngFor="let levels of visibleChatData" >
      
      <div class="chat-content" [ngClass]="{'user-content': !!Options.user}" *ngFor="let Options of levels.Level; let isFirst = first; let isLast = last">
        <div class="chat-header" *ngIf="isFirst && !Options.user">
          <img src="/assets/images/chat_icon.svg" alt="Chat icon" />
            <span class="name">MS Bot</span>
            <span class="date">{{Options.selectedDate}}</span>
            <span class="date">{{Options.selectedTime}}</span>
        </div>
        <div class="chat-header user" *ngIf="isFirst && Options.user" >
          <motif-avatar size="small"
          [src]="$any(userService.userDetails?.pictureBase64)"
          [userName]="$any(userService.userDetails?.displayName)">
</motif-avatar>
          <span class="name">{{ userService.userDetails?.displayName }}</span>
          <span class="date">{{Options.selectedDate}}</span>
            <span class="date">{{Options.selectedTime}}</span>
      </div>
        <label
          class="chat-message bot-message"
          [class]="{
            'selected': !!Options.selected
          }"
          (click)="Options?.responses && !Options.user && selectChoice(Options.id)">
          {{ Options.title }}  
          <a *ngIf="Options.contentURL && Options.contentURL.length" [href]="" (click)="navigateToUrl(Options.contentURL)"> Click here to open</a>       
          <ng-container *ngIf="Options.title === 'Please select the engagement.'">
            <app-engagement-list></app-engagement-list>
          </ng-container>
        </label>
      
<div *ngIf="isLast && !Options.user && !Options.initialOptions" class="action-wrapper">
  <button (click)="showInitialOptions(false)" class="chat-action-btn go-back">Go Back</button>
  <button (click)="closeChatbot()" class="chat-action-btn close-chat">Close Chat</button>

</div>
      </div>
    </div>
  </ng-container>
    <ng-template #errorBlock>
      {{errorMessage}}
    </ng-template>
  </div>
  <div class="chatbot-footer">
    <p>{{chatData.welcomeText}}</p>
  </div>
  <ng-template #loaderBlock>
    <app-loader></app-loader>
  </ng-template>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
  <!-- <input type="text" class="chat-input"  (keyup.enter)="sendMessage()" placeholder="Type a message..."/> -->
</div>
